import React from 'react';
import Modal from './Modal';
import Button from './Button';
import styles from './ConfirmDialog.module.css';

const ConfirmDialog = ({
    isOpen,
    title = 'Please confirm',
    message = 'Are you sure you want to continue?',
    details,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    tone = 'danger',
    onConfirm,
    onCancel,
}) => {
    const footer = (
        <>
            <Button type="button" variant="secondary" size="sm" onClick={onCancel}>
                {cancelText}
            </Button>
            <Button
                type="button"
                variant={tone === 'danger' ? 'danger' : 'primary'}
                size="sm"
                onClick={onConfirm}
            >
                {confirmText}
            </Button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            title={title}
            footer={footer}
            size="sm"
            closeOnOverlay={false}
        >
            <div className={styles.body}>
                <p className={styles.message}>{message}</p>
                {details && (
                    <div className={styles.details}>
                        {details}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default ConfirmDialog;
